import { Platform } from "react-native";
import { useAppSelector } from "./useAppSelector";

export default function useIsSSO() {
  const { authMethod } = useAppSelector((state) => state.auth);
  const isSSO = Platform.OS === "web" && authMethod !== undefined;
  return { authMethod, isSSO };
}
